<template>
  <div>
    <!-- DESCRIPTION -->
    <template v-if="$isNotEmpty(data.description_room_rate) || $isNotEmpty(data.description_promotion)">
      <p class="pt-4 mb-1 body-3-3 text-14 font-bold">{{$t('general.description')}}</p>
      <p v-if="$isNotEmpty(data.description_room_rate)" class="mb-0 body-3-3 text-14 font-regular" v-html="$convertNewlinesToBr(data.description_promotion)"></p>
      <span v-if="$isNotEmpty(data.description_room_rate) && $isNotEmpty(data.description_promotion)" class="my-2 w-100 d-block"></span>
      <p v-if="$isNotEmpty(data.description_promotion)" class="mb-0 body-2-1 text-14 font-regular" v-html="$convertNewlinesToBr(data.description_promotion)"></p>
    </template>

    <!-- CANCELLATION POLICY -->
    <template v-if="data.cancellation_policy != null">
      <div class="d-block mb-3 mt-4">
        <p class="mb-1 body-3-3 text-14 font-bold">{{data.cancellation_policy.title}}</p>
        <p class="mb-0 body-3-3 text-14 font-regular html-desc" v-html="data.cancellation_policy.description"></p>
      </div>
    </template>

    <!-- TERMS & CONDITIONS -->
    <template v-if="$isNotEmpty(data.term_and_condition_room_rate) || $isNotEmpty(data.term_and_condition_promotion)">
      <div class="d-block mb-3 mt-4">
        <div class="mb-3" v-if="$isNotEmpty(data.term_and_condition_room_rate)">
          <p class="mb-1 body-3-3 text-14 font-bold">{{data.term_and_condition_room_rate.title}}</p>
          <p class="mb-0 body-3-3 text-14 font-regular html-desc" v-html="data.term_and_condition_room_rate.description"></p>
        </div>
        <div v-if="$isNotEmpty(data.term_and_condition_promotion)">
          <p class="mb-1 body-3-3 text-14 font-bold">{{data.term_and_condition_promotion.title}}</p>
          <p class="mb-0 body-3-3 text-14 font-regular html-desc" v-html="data.term_and_condition_promotion.description"></p>
        </div>
      </div>
    </template>

    <!-- RATE INCLUSIONS -->
    <template v-if="data.rate.inclusion.length > 0">
      <p class="pt-3 mb-1 body-3-3 text-14 font-bold">{{$t('hotel.room-type.include-in-rate')}}</p>
      <div class="height-auto">
        <ul  class="pl-3">
          <li class="mb-2" v-for="(inclusion, index) in data.rate.inclusion">
            <span class="body-2-1 d-block">{{inclusion.inclusion_item.name}}</span>
            <span class="body-2 restrict-p-mb html-desc" v-html="inclusion.inclusion_item.description"></span>
          </li>
        </ul>
      </div>
    </template>

    <!-- BREAKDOWN RATE -->
    <template v-if="roomAvbl(data.room_type.id,data.id) > 0 && showRatePackageBreakdown(data.rate.is_package)">
      <p class="mt-4 mb-2 body-2-2 text-14 font-bold">{{$t('hotel.rate-breakdown.title')}}</p>
      <template v-for="(rate,index) in data.dates">
        <div class="row slim-grid-row" :class="{'border-bottom-dashed mb-2 pb-3' : index+1 === data.dates.length}">
          <div class="col-6">
            <p class="mb-0 body-3-3-2">{{customFormatDateTime(rate.date)}}</p>
            <!-- PROMO COMBINE -->
            <p v-if="rate.promotion_price < 0 && promotionCounter(rate.promo_combine) != ''" class="text-green mb-0 body-3-3-2 font-regular text-truncate">{{promotionCounter(rate.promo_combine)}}</p>
          </div>
          <div class="col-6 text-right">
            <!-- PROMO COMBINE -->
            <div class="w-100 no-ws">
              <!-- PROMO COMBINATION -->
              <p v-if="rate.promotion_price < 0 && promotionCounter(rate.promo_combine) != ''" class="mb-0 d-inline-block align-middle mr-2 font-lato text-12 text-orange">{{ +parseFloat(100-$getPercentage(rate.price+rate.extra_guest_price, printTotalPriceWithTax(rate.final_price, rate.taxes),2)).toFixed(2) }}%</p>
              <p class="mb-0 text-12" :class="{'text-line-through d-inline-block align-middle text-subcolor font-lato-regular': rate.promotion_price < 0 && promotionCounter(rate.promo_combine) != '', 'text-dark font-lato' : rate.promotion_price >= 0}">
                <template v-if="rate.promotion_price < 0 && promotionCounter(rate.promo_combine) != ''">
                  {{formatCurrency(rate.price+rate.extra_guest_price)}}
                </template>
                <template v-else>
                  {{formatCurrency(printTotalPriceWithTax(rate.final_price, rate.taxes))}}
                </template>
              </p>
              <!-- PROMO COMBINATION -->
              <p v-if="rate.promotion_price < 0 && promotionCounter(rate.promo_combine) != ''" class="mb-0 font-lato text-14">{{ $formatCurrency(printTotalPriceWithTax(rate.final_price, rate.taxes))}}</p>
              <!-- <p v-if="rate.promotion_price < 0 && rate.promotion.promotion_type != 'REMAINING_OCCUPANCY'" class="text-orange mb-0 body-2-2 font-regular">{{formatCurrency(rate.final_price)}}</p> -->
            </div>
          </div>
        </div>
        <div v-if="(index+1) < data.dates.length" class="border-bottom-dashed w-100 my-2"></div>
      </template>
    </template>
  </div>
</template>
<script>
	import {formatCurrency,customFormatDateTime,inputCustomOnly,roomAvbl} from '@/utils/index.js'
  import {mapGetters,mapMutations} from 'vuex'
	export default{
		props: {
			data:{
				type: Object,
				default: () => {}
			}
		},
		data(){
			return{
				images: [],
				booking_detail_rate: false,
				index: null,
        rate_detail: '',
        is_popup_avlb: false,
        is_popup_avlb_form: false,
        more_room: 5,
        more_inclusions: true
			}
		},
    computed:{
      total_guest_included(){
        let total = this.getBeFilter().guest.adult+this.getBeFilter().guest.child+this.getBeFilter().guest.infant
        if(total  <= this.data.rate.guest_included){
          return total
        }else{
          return this.data.rate.guest_included
        }
      },
      selected_room_rate(){
        let display = 0
        if(this.getBeCartRoom().length > 0){
          let record = this.getBeCartRoom().findIndex(x=>x.room_rate.id == this.data.id)
          if(record != -1){
            display = this.getBeCartRoom()[record].qty
          }
        }
        return display
      },
      is_room_avlb_not_valid(){
        let display = false
        if(this.more_room == '' || this.more_room == 0 || this.more_room > this.roomAvbl(this.data.room_type.id,this.data.id)){
          display = true
        }
        return display
      }
    },
		methods:{
      ...mapGetters(['getBeSortBy','getBeFilter','getBeCartRoom', 'getMerchant']),
      ...mapMutations(['BeManipulateRoomRate','changeBeRoomAvbl', 'beRemoveRoomRate']),
      showRatePackageBreakdown(isPackage){
        const { search_room_is_show_rate_package_daily_breakdown: configMerchant = false } = this.getMerchant();
        return configMerchant ? true : !isPackage;
      },
      printTotalPriceWithTax(price, taxes){
        const showTax = this.getMerchant().search_room_is_show_tax_fee_note
        return showTax ? price : price - taxes
      },
      inputCustomOnly($event){
        inputCustomOnly('number',$event)
      },
      roomAvbl(room_type_id,room_rate_id,limit=false){
        return roomAvbl(room_type_id,room_rate_id,limit)
      },
      customFormatDateTime(date){
      	return customFormatDateTime(date,'YYYY-MM-DD','DD MMM YYYY')
      },
      formatCurrency(value){
        return formatCurrency(value);
      },
      // PROMO COMBINATION
      promotionCounter(data){
        let promotion = ''
        if(data != null){
          for(let i = data.promotion_list.length-1; i >= 0; i--){
            let item = data.promotion_list[i]
            let validate = {
              price: item.promotion_price < 0,
              not_ro: item.promotion_type != 'REMAINING_OCCUPANCY',
              is_apply: item.is_apply
            }
            if(validate.price && validate.not_ro && validate.is_apply){
              if(promotion == ''){
                promotion += item.name
              }else{
                promotion += `, ${item.name}`
              }
            }
          }
        }
        return promotion
      },
      total_rates(data){
        const showTax = this.getMerchant().search_room_is_show_tax_fee_note
      	let display = 0
				for(let i = 0 ; i < data.length; i++){
					display += data[i].final_price
          if(!showTax) display -= data[i].taxes
				}
				return display
      },
      close(){
      	this.$emit("close")
      },
      toggleRateDetail(date = ''){
        // this.rate_detail = ((this.rate_detail != '' && ) || (this.rate_detail == '' && date == '')) ? '' : date
        if(this.rate_detail == ''){
          this.rate_detail = date != '' ? date : ''
        }else{
          if(date == this.rate_detail){
            this.rate_detail = ''
          }else{
            this.rate_detail = date
          }
        }
      },
      roomVisible(avlb){
        return (avlb < 5) ? avlb : 6
      },
      toggleRoomAvlb(cancel=false,close=false){
        this.more_room = this.selected_room_rate
        if(cancel){
          this.is_popup_avlb_form = false
        }else{
          if(close){
            this.is_popup_avlb_form = false
            this.is_popup_avlb = false
          }else{
            this.is_popup_avlb_form = true
            let self = this
            this.$nextTick(() => {
              self.$refs.inputmore.focus()
              self.$refs.inputmore.select()
            })
          }
        }
      },
      updateRoomTypeAvailability(qty, currentRoomRate, action){
        const { 
          id: rr_id, 
          room_type: { id, is_virtual, availability_affected } 
        } = currentRoomRate
        let availabilityParams = { 
          id, 
          rr_id, 
          is_virtual, 
          availability_affected, 
          action,
          qty 
        }
        this.changeBeRoomAvbl(availabilityParams);
      },
      generateRemainingGuestFilter(){
        const GUEST_TYPE = ['adult','child','infant'];

        let remainingGuestFilter = this.$deepCopy(this.getBeFilter().guest)
        this.getBeCartRoom().forEach(savedRoomRate => {
          savedRoomRate.guest.forEach(savedRoomRateGuest => {
            const { included, extra } = savedRoomRateGuest;
            
            const savedGuestsPerRoomRate = GUEST_TYPE.reduce((acc, key) => {
              acc[key] = included[key] + extra[key];
              return acc;
            }, {});

            GUEST_TYPE.forEach(guest => {
              if(remainingGuestFilter[guest] > 0){
                remainingGuestFilter[guest] -= savedGuestsPerRoomRate[guest]
              } else {
                remainingGuestFilter[guest] = 0
              } 
            })
          });
        })
        return remainingGuestFilter
      },
      includeGuestParamsIfZeroTotal(guest_included, roomConfig){
        let guestIncluded = { adult: 0, child: 0, infant: 0 }
        const currentGuestFilter = this.$deepCopy(this.getBeFilter().guest)

        const { use_max_guest_by_pax, max_guests, max_guest_adult, max_guest_children, max_guest_infant } = roomConfig
        
        if(use_max_guest_by_pax){
          guestIncluded.adult = Math.min(guest_included, max_guest_adult);

          let remainingPax = guest_included - guestIncluded.adult;

          if (currentGuestFilter.child > 0 && remainingPax > 0) {
            guestIncluded.child = Math.min(remainingPax, max_guest_children);
            remainingPax -= guestIncluded.child;
          }

          if (currentGuestFilter.infant > 0 && remainingPax > 0) {
            guestIncluded.infant = Math.min(remainingPax, max_guest_infant);
          }
        }else{
          if(currentGuestFilter.adult > guest_included){
            guestIncluded = { adult: guest_included, child: 0, infant: 0 }
          }else{
            guestIncluded.adult = currentGuestFilter.adult
            const remainingGuestIncludedAfterAdult = guest_included - currentGuestFilter.adult
        
            if(remainingGuestIncludedAfterAdult > 0){
              
              if(currentGuestFilter.child > remainingGuestIncludedAfterAdult){
                guestIncluded.child = remainingGuestIncludedAfterAdult
              }else{
                guestIncluded.child = currentGuestFilter.child
                const { adult, child } = guestIncluded
                const remainingGuestIncludedAfterAdultChild = guest_included - (adult + child)
                const isInfantExist = currentGuestFilter.infant > remainingGuestIncludedAfterAdultChild
                if(remainingGuestIncludedAfterAdultChild > 0 && isInfantExist){
                  guestIncluded.infant = remainingGuestIncludedAfterAdultChild
                }
              }
            }
          }
        }
        return guestIncluded;
      },
      allocateGuestPerRoom(guestParamsIncluded, remainingGuestFilter, guest_included){
        let includedGuest = guestParamsIncluded
        let remainingGuest = remainingGuestFilter
        
        const GUEST_TYPE = ['adult','child','infant'];
        GUEST_TYPE.forEach(guest => {
          let totalGuestIncludedPerRoom = Object.values(includedGuest).reduce((sum, value) => sum + value, 0);
          if(remainingGuest[guest] > 0 && totalGuestIncludedPerRoom < guest_included){
            let remainingPaxPerRoom = guest_included - totalGuestIncludedPerRoom
            if(remainingGuest[guest] > guest_included){
              includedGuest[guest] = remainingPaxPerRoom
              remainingGuest[guest] -= remainingPaxPerRoom
            }else{
              includedGuest[guest] = remainingPaxPerRoom > remainingGuest[guest] ? remainingGuest[guest] : remainingPaxPerRoom
              remainingGuest[guest] -= includedGuest[guest]
            }
          }
        });
        return { includedGuest, remainingGuest }
      },
      allocateSpecificGuestPerRoom(remainingGuests, maxGuests, includedGuests){
        let allocatedGuests = { adult: 0, child: 0, infant: 0 };
        let remainingIncluded = includedGuests;

        const allocate = (type) => {
          if (remainingIncluded <= 0) return;
          const count = Math.min(remainingGuests[type], maxGuests[type], remainingIncluded);
          allocatedGuests[type] = count;
          remainingGuests[type] -= count;
          remainingIncluded -= count;
        }

        allocate('adult');
        allocate('child');
        allocate('infant');

        return allocatedGuests;
      },
      generateRoomRateGuestParam(selectedRoomRateQty, currentRoomRate){
        let finalCountGuests = []
        
        const { rate, room_type } = currentRoomRate
        const {
          use_max_guest_by_pax = false,
          max_guests = null,
          max_guest_adult = 0,
          max_guest_children = 0,
          max_guest_infant = 0,
        } = rate.max_guests ? rate : room_type;
        const roomConfig = {use_max_guest_by_pax, max_guests, max_guest_adult, max_guest_children, max_guest_infant}

        const GUEST_TYPE = ['adult','child','infant'];
        let remainingGuestFilter = this.generateRemainingGuestFilter()
        const totalRemainingGuestFilter = Object.values(remainingGuestFilter).reduce((sum, value) => sum + value, 0)

        for (let i = 0; i < selectedRoomRateQty; i++) {
          let guestParams = {
            included: { adult: 0, child: 0, infant: 0 },
            extra: { adult: 0, child: 0, infant: 0 },
          }
          
          if(totalRemainingGuestFilter === 0){
            guestParams.included = this.includeGuestParamsIfZeroTotal(rate.guest_included, roomConfig)
            finalCountGuests.push(guestParams);
          }else{
            
            // Calculate guest included
            if(use_max_guest_by_pax){
              const maxGuests = { adult: max_guest_adult, child: max_guest_children, infant: max_guest_infant };
              guestParams.included = this.allocateSpecificGuestPerRoom(remainingGuestFilter, maxGuests, rate.guest_included);
            }else{
              if(totalRemainingGuestFilter > rate.guest_included){
                const { includedGuest, remainingGuest } = this.allocateGuestPerRoom(guestParams.included, remainingGuestFilter, rate.guest_included)
                guestParams.included = includedGuest
                remainingGuestFilter = remainingGuest
              }else{
                guestParams.included = remainingGuestFilter
                remainingGuestFilter = { adult: 0, child: 0, infant: 0 }
              }
            }

            finalCountGuests.push(guestParams);

            // Calculate extra guest
            const isLastLooper = i+1 === selectedRoomRateQty;
            if(isLastLooper){
              let notIncludedGuest = Object.values(remainingGuestFilter).reduce((sum, value) => sum + value, 0)

              if(notIncludedGuest > 0){
                for(let j = 0; j < selectedRoomRateQty; j++){
                  let guestPerQtyRoom = finalCountGuests[j]
                  if(use_max_guest_by_pax){
                    const maxGuestsPerType = { adult: max_guest_adult, child: max_guest_children, infant: max_guest_infant };
                    const guestIncluded = guestPerQtyRoom.included
                    
                    for (const type of GUEST_TYPE){
                      let remainingPaxForExtra = maxGuestsPerType[type] - guestIncluded[type];
                      if(remainingPaxForExtra <= 0) continue;

                      const totalCurrentGuest = Object.values(finalCountGuests[j]).flatMap(Object.values).reduce((a, b) => a + b, 0);
                      if(max_guests <= totalCurrentGuest) continue;

                      const remainingFromMaxGuests = max_guests - totalCurrentGuest;
                      const extraFinal = Math.min(remainingPaxForExtra, remainingGuestFilter[type], remainingFromMaxGuests);
                      finalCountGuests[j].extra[type] = extraFinal;
                      remainingGuestFilter[type] -= extraFinal;
                    }

                  }else{
                    let totalGuestIncludedPerRoom = Object.values(guestPerQtyRoom.included).reduce((sum, value) => sum + value, 0);  
                    let remainingPaxForExtra = max_guests-totalGuestIncludedPerRoom

                    for (const type of GUEST_TYPE) {
                      if (remainingGuestFilter[type] > 0) {
                        const extraFinal = Math.min(remainingPaxForExtra, remainingGuestFilter[type]);
                        finalCountGuests[j].extra[type] = extraFinal;
                        remainingGuestFilter[type] -= extraFinal;
                      }
                      
                    }
                  }
                }
              }
            }
          }
        }

        return finalCountGuests;
      },
      addRoomRate(qty, selectedRoomRate){
        const validQty = parseInt(qty);
        const currentRoomRate = this.$deepCopy(selectedRoomRate)
        
        const savedRoom = this.$deepCopy(this.getBeCartRoom())
        let savedRoomRateIndex = savedRoom.findIndex(savedRoomRate=>savedRoomRate.room_rate.id === currentRoomRate.id)
        
        if(savedRoomRateIndex != -1){
          this.beRemoveRoomRate(currentRoomRate.id);
          this.updateRoomTypeAvailability(savedRoom[savedRoomRateIndex].qty, currentRoomRate, 'inc')
          setTimeout(()=>{
            this.addRoomRate(validQty, currentRoomRate)
          },100)
        } else {
          this.updateRoomTypeAvailability(validQty, currentRoomRate, 'dec')
          const roomRateParam = {
            room_rate: currentRoomRate,
            qty: validQty,
            guest: this.generateRoomRateGuestParam(validQty, currentRoomRate)
          }
          this.BeManipulateRoomRate(roomRateParam)
          setTimeout(()=>{
            this.close()
          },100)
        }
      },
      isToggle(type,data){
        if (type == 'policy') {
          this.more_policy = data
        }else if(type == 'inclusions') {
          this.more_inclusions = data
        }
      },
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/mobile/roomRateDetailInline.vue